<template>
  <div class="zhanwei4"></div>
  <el-tabs
    v-model="activeName"
    type="card"
    class="demo-tabs"
    @tab-click="handleClick"
  >
    <el-tab-pane label="游学证明" name="first">
      <div class="prove">
        <img
          :src="
            baseImage == ''
              ? 'https://nanchangfile.oss-cn-beijing.aliyuncs.com/prove.png'
              : baseImage
          "
          alt=""
        />
      </div>
      <div class="btns">
        <el-upload
          ref="upload"
          class="upload-demo"
          :on-change="changeFile"
          :on-exceed="handleExceed"
          :on-success="onSuccess"
          :action="UpdateApi"
          :limit="1"
          :auto-upload="false"
        >
          <template #trigger>
            <el-button type="primary">选择文件</el-button>
          </template>
          <el-button class="ml-3" type="success" @click="submitUpload">
            上传到服务器
          </el-button>
        </el-upload>
      </div>
    </el-tab-pane>
    <el-tab-pane label="调查问卷" name="second">
      <feedback></feedback>
    </el-tab-pane>
  </el-tabs>
</template>

<script lang="ts">
import { genFileId, TabsPaneContext, UploadRawFile } from "element-plus";
import { defineComponent, ref } from "vue";
import { uploadImgToBase64 } from "@/utils";
import feedback from "@/components/questionnaires/admin/feedback.vue";
interface Data {
  title: string;
  counter: number;
  message: string;
  data: any;
  loading: boolean;
  error: string;
  boxRef: HTMLElement | null;
}

export default defineComponent({
  name: "App",
  data(): any {
    return {
      title: "欢迎来到Vue 3页面模版",
      counter: 0,
      message: "",
      data: null,
      loading: false,
      error: "",
      boxRef: null,
      activeName: "first",
      baseImage: "",
      game: null,
    };
  },
  components: {
    feedback,
  },
  computed: {
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  watch: {
    counter(newVal: number, oldVal: number) {
      console.log(`Counter changed from ${oldVal} to ${newVal}`);
    },
    message(newVal: string, oldVal: string) {
      console.log(`Message changed from "${oldVal}" to "${newVal}"`);
    },
  },
  mounted() {
    let game = this.$store.state.game.games.find((item: any) => {
      return item.id == this.$route.params.id;
    });
    this.game = game;
    if (game.proveImg) {
      this.baseImage = game.proveImg;
    }
  },
  methods: {
    handleClick(tab: TabsPaneContext, event: Event) {},
    handleExceed(files: any) {
      this.$refs.upload.clearFiles();
      const file = files[0] as UploadRawFile;
      file.uid = genFileId();
      this.$refs.upload.handleStart(file);
    },
    onSuccess(file) {
      if (file.data.returnFileUrl) {
        this.game.proveImg = file.data.returnFileUrl;
        this.game.carousel = "";
        this.game.tips = JSON.stringify(this.game.tips);

        this.$store
          .dispatch("game/updateGame", { gameBean: this.game })
          .then((res) => {});
      }
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    async changeFile(files: any) {
      let base64 = await uploadImgToBase64(files.raw);
      this.baseImage = base64.result;
    },
  },
});
</script>

<style lang="less" scoped>
.demo-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}

.prove {
  width: calc(390px / 1.5);
  height: calc(844px / 1.5);
  margin: auto;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.btns {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-demo {
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    margin-left: 10px;
  }
}
</style>
